import React, { useState, useEffect } from 'react';
import { callBlock, helperText } from './MakeACall.module.css';
import { makeACall } from '../../common/constants/api';
import Toast from '../../common/components/Toast/Toast';
import NewSpinner from '../../common/components/NewSpinner/NewSpinner';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';

const MakeACall = ({
  CustomIcon,
  phoneNumber,
  leadId,
  applicantId,
  callContainerClasses,
  helperTextClasses,
  helperMessage,
  callWrapperClasses = 'bg-white rounded-full shadow px-1 py-1',
  spinnerStyles = {},
  loadingWrapperClasses,
  phoneCallStyles = { color: 'rgb(56 169 56)' },
  PhoneNumberClasses = 'font-roboto ml-2',
  showCountryCode = true,
  onSuccessCall,
  onFailureCall,
  callWrapperStyle = {}
}) => {
  const [isCallProgress, setIsCallProgress] = useState(false);

  const doCall = () => {
    setIsCallProgress(true);
    makeACall(leadId, applicantId)
      .then(res => {
        setIsCallProgress(false);
        Toast('success', 'Phone call connected!', 3000, 'top-center');
        if (typeof onSuccessCall == 'function') onSuccessCall();
      })
      .catch(err => {
        setIsCallProgress(false);
        if (typeof onFailureCall == 'function') onFailureCall();
      });
  };
  const PhoneIcon = () => {
    if (CustomIcon) return <CustomIcon style={{ ...phoneCallStyles }} />;
    return <PhoneInTalkIcon style={{ ...phoneCallStyles }} />;
  };
  return (
    <div
      className={`w-full flex items-center cursor-pointer relative  ${callBlock} ${callContainerClasses}`}
      onClick={phoneNumber && leadId && applicantId && doCall}
    >
      <React.Fragment>
        <span
          className={`${helperText} shadow-md font-khand text-sm font-medium rounded ${helperTextClasses}`}
        >
          {helperMessage || 'Make a call'}
        </span>
        <div className={` ${callWrapperClasses}`} style={callWrapperStyle}>
          {isCallProgress ? (
            <div
              className={`table mx-auto text-center ${loadingWrapperClasses}`}
            >
              <NewSpinner
                styleObj={{
                  width: '1.5rem',
                  height: '1.5rem',
                  borderTopColor: '#3498db',
                  borderWidth: '3px',
                  borderTopWidth: '3px',
                  ...spinnerStyles
                }}
              />
            </div>
          ) : (
            <PhoneIcon />
          )}
        </div>
        <span className={`${PhoneNumberClasses}`}>
          {(!phoneNumber && <span className="text-center">---</span>) || (
            <span>
              {showCountryCode && '+91-'}
              {phoneNumber}
            </span>
          )}
        </span>
      </React.Fragment>
    </div>
  );
};

export default withErrorHandler(MakeACall);
